import { render, staticRenderFns } from "./scoreRatio.vue?vue&type=template&id=4623b6ca&scoped=true"
import script from "./scoreRatio.vue?vue&type=script&lang=js"
export * from "./scoreRatio.vue?vue&type=script&lang=js"
import style0 from "./scoreRatio.vue?vue&type=style&index=0&id=4623b6ca&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623b6ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4623b6ca')) {
      api.createRecord('4623b6ca', component.options)
    } else {
      api.reload('4623b6ca', component.options)
    }
    module.hot.accept("./scoreRatio.vue?vue&type=template&id=4623b6ca&scoped=true", function () {
      api.rerender('4623b6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/product-score-rules/form/components/scoreRatio.vue"
export default component.exports